/* Tmedals V045 — V044 intact + accurately dated New Arrivals; Yotpo, sticky buying, carousels and load-more preserved */
(() => {
  document.documentElement.classList.add('tm-js');
  const q = (selector, root = document) => root.querySelector(selector);
  const qa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  let stickyOffsetFrame = 0;

  function updateStickyOffset() {
    const header = q('[id^="TMHeader-"]');
    let top = 16;

    /* Use only the part of the header that is actually visible in the viewport.
     * If the header scrolls away, the purchase card rises to 16px from the top.
     * If the header is genuinely sticky, the card stays directly below it.
     */
    if (header) {
      const rect = header.getBoundingClientRect();
      if (rect.bottom > 0) top = Math.max(16, Math.ceil(rect.bottom) + 16);
    }

    document.documentElement.style.setProperty('--tm-product-sticky-top', `${top}px`);
  }

  function requestStickyOffsetUpdate() {
    if (stickyOffsetFrame) return;
    stickyOffsetFrame = requestAnimationFrame(() => {
  document.documentElement.classList.add('tm-js');
      stickyOffsetFrame = 0;
      updateStickyOffset();
    });
  }


  function runYotpoInitializersOnce(tabs) {
    let ran = false;

    /* V044: never repeatedly re-initialize an already mounted Yotpo widget.
       V043 retried initWidgets many times for up to nine seconds; that could
       trigger expensive re-renders and made the Reviews tab feel slower.
       Here each available Yotpo runtime is invoked at most once per tab block. */
    try {
      if (tabs.dataset.tmYotpo3Init !== 'true' &&
          window.yotpoWidgetsContainer &&
          typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
        window.yotpoWidgetsContainer.initWidgets();
        tabs.dataset.tmYotpo3Init = 'true';
        ran = true;
      }
    } catch (error) {
      /* Third-party errors must never block product-page controls. */
    }

    try {
      if (tabs.dataset.tmYotpoLegacyInit !== 'true' &&
          window.yotpo &&
          typeof window.yotpo.initWidgets === 'function') {
        window.yotpo.initWidgets();
        tabs.dataset.tmYotpoLegacyInit = 'true';
        ran = true;
      }
    } catch (error) {
      /* Same protection for the legacy loader. */
    }

    if (ran) requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
    return ran;
  }

  function primeYotpoReviews(tabs) {
    if (!tabs || tabs.dataset.tmYotpoPrimeStarted === 'true') return;
    tabs.dataset.tmYotpoPrimeStarted = 'true';

    /* Poll only for the loader becoming available; do not keep calling it.
       Shopify app extensions can expose Yotpo slightly after our deferred theme
       JS. The invisible fixed review panel gives Yotpo a viewport-sized target,
       so its own lazy loading can also start before the tab is clicked. */
    let tries = 0;
    const attempt = () => {
      tries += 1;
      runYotpoInitializersOnce(tabs);
      const has3 = tabs.dataset.tmYotpo3Init === 'true';
      const hasLegacy = tabs.dataset.tmYotpoLegacyInit === 'true';
      if (has3 || hasLegacy || tries >= 24) {
        window.clearInterval(timer);
      }
    };

    attempt();
    const timer = window.setInterval(attempt, 250);
  }

  function refreshVisibleReviews(tabs) {
    const slot = q('.tm-product-tabs__reviews-slot', tabs);
    if (!slot) return;
    /* The widget should already be hydrated. A width read + resize is enough
       to let either Yotpo generation recalculate after switching from the
       invisible preload target to the real in-flow Reviews panel. */
    slot.getBoundingClientRect();
    window.dispatchEvent(new Event('resize'));
    requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
    runYotpoInitializersOnce(tabs);
  }

  function initTabs() {
    qa('[data-tm-product-tabs]').forEach((tabs) => {
      if (tabs.dataset.tmTabsReady === 'true') return;
      tabs.dataset.tmTabsReady = 'true';

      const buttons = qa('[data-tm-tab]', tabs);
      const panels = qa('[data-tm-panel]', tabs);
      const activate = (name) => {
        buttons.forEach((button) => {
          const active = button.dataset.tmTab === name;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
          button.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => {
          const active = panel.dataset.tmPanel === name;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        if (name === 'reviews') {
          refreshVisibleReviews(tabs);
        }
      };

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(button.dataset.tmTab));
        button.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const delta = event.key === 'ArrowRight' ? 1 : -1;
          const next = buttons[(index + delta + buttons.length) % buttons.length];
          next.focus();
          activate(next.dataset.tmTab);
        });
      });

      /* Start Yotpo after the primary product UI has initialized. The Reviews
         panel remains invisibly fixed in the viewport so the app can hydrate
         before the shopper clicks the tab. */
      const prime = () => primeYotpoReviews(tabs);
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(prime, { timeout: 900 });
      } else {
        window.setTimeout(prime, 350);
      }
    });
  }

  function updateCarouselState(root) {
    const track = q('[data-tm-carousel-track]', root);
    const prev = q('[data-tm-carousel-prev]', root);
    const next = q('[data-tm-carousel-next]', root);
    if (!track || !prev || !next) return;
    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= maxScroll;
  }

  function initCarousel(root) {
    if (!root || root.dataset.tmCarouselReady === 'true') {
      if (root) updateCarouselState(root);
      return;
    }
    const track = q('[data-tm-carousel-track]', root);
    const prev = q('[data-tm-carousel-prev]', root);
    const next = q('[data-tm-carousel-next]', root);
    if (!track || !prev || !next) return;

    root.dataset.tmCarouselReady = 'true';
    const move = (direction) => {
      const distance = Math.max(track.clientWidth * 0.92, 260);
      track.scrollBy({ left: direction * distance, behavior: 'smooth' });
    };
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', () => updateCarouselState(root), { passive: true });
    window.addEventListener('resize', () => updateCarouselState(root), { passive: true });
    updateCarouselState(root);
  }

  function initCarousels() {
    qa('[data-tm-carousel]').forEach((viewport) => {
      const root = viewport.closest('.tm-product-shelf') || viewport.closest('product-recommendations');
      if (root) initCarousel(root);
    });
  }

  function cardProductPath(item) {
    const link = q('.card__heading a, a.full-unstyled-link, a[href*="/products/"]', item);
    if (!link) return '';
    try { return new URL(link.getAttribute('href'), window.location.origin).pathname.replace(/\/$/, ''); }
    catch (_) { return ''; }
  }

  async function loadNewArrivals(section) {
    if (section.dataset.tmNewArrivalsLoaded === 'true') return;
    section.dataset.tmNewArrivalsLoaded = 'true';
    const track = q('[data-tm-carousel-track]', section);
    if (!track) return;

    const limit = Math.max(1, parseInt(section.dataset.limit || '16', 10));
    const currentPath = (() => {
  document.documentElement.classList.add('tm-js');
      try { return new URL(section.dataset.currentProductUrl || window.location.pathname, window.location.origin).pathname.replace(/\/$/, ''); }
      catch (_) { return window.location.pathname.replace(/\/$/, ''); }
    })();
    const source = section.dataset.sourceUrl;
    if (!source) return;

    try {
      const response = await fetch(source, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const sourceItems = qa('#product-grid > li', doc);
      if (!sourceItems.length) throw new Error('No product cards returned');

      const fresh = [];
      const seen = new Set();
      sourceItems.forEach((item) => {
        if (fresh.length >= limit) return;
        const path = cardProductPath(item);
        if (!path || path === currentPath || seen.has(path)) return;
        seen.add(path);
        const clone = item.cloneNode(true);
        clone.removeAttribute('style');
        clone.removeAttribute('data-cascade');
        clone.className = 'tm-product-shelf__item tm-new-arrival-item';
        // Keep the badge/date rendered by Liquid (90d NEW, 180d Added).
        // Older products must not receive a blanket NEW label.
        fresh.push(clone);
      });

      if (fresh.length) {
        track.replaceChildren(...fresh);
        const status = q('[data-tm-new-arrivals-status]', section);
        if (status) status.textContent = `${fresh.length} newest products loaded.`;
      }
      updateCarouselState(section);
    } catch (error) {
      // Server-rendered cards remain as a safe fallback when the collection request is unavailable.
      updateCarouselState(section);
    }
  }

  function initNewArrivals() {
    qa('[data-tm-new-arrivals]').forEach(loadNewArrivals);
  }

  function initNewArrivalsArchive() {
    qa('[data-tm-new-arrivals-pager]').forEach((pager) => {
      if (pager.dataset.tmPagerReady === 'true') return;
      const button = q('[data-tm-new-arrivals-load-more]', pager);
      const grid = q('#product-grid');
      if (!button || !grid) return;

      pager.dataset.tmPagerReady = 'true';
      button.addEventListener('click', async () => {
        const nextUrl = button.dataset.nextUrl;
        if (!nextUrl || button.disabled) return;

        const originalLabel = button.textContent;
        button.disabled = true;
        button.textContent = 'Loading…';
        pager.classList.add('is-loading');

        try {
          const response = await fetch(nextUrl, {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const incoming = qa('#product-grid > li', doc);
          if (!incoming.length) throw new Error('No products returned');

          incoming.forEach((item) => {
            const clone = item.cloneNode(true);
            clone.classList.remove('scroll-trigger', 'animate--slide-in');
            clone.removeAttribute('data-cascade');
            clone.removeAttribute('style');
            grid.appendChild(clone);
          });

          const nextButton = q('[data-tm-new-arrivals-load-more]', doc);
          const status = q('[data-tm-new-arrivals-count]', pager);
          const total = parseInt(pager.dataset.total || '0', 10);
          if (status) {
            const shown = qa('#product-grid > li').length;
            status.textContent = total > 0 ? `Showing ${Math.min(shown, total)} of ${total}` : `${shown} items shown`;
          }

          if (nextButton && nextButton.dataset.nextUrl) {
            button.dataset.nextUrl = nextButton.dataset.nextUrl;
            button.disabled = false;
            button.textContent = originalLabel;
          } else {
            button.remove();
            pager.classList.add('is-complete');
          }
        } catch (error) {
          button.disabled = false;
          button.textContent = 'Try Again';
        } finally {
          pager.classList.remove('is-loading');
        }
      });
    });
  }

  function readablePrice(productInfo) {
    const sale = q('.price-item--sale', productInfo);
    const regular = q('.price-item--regular', productInfo);
    const node = sale && sale.offsetParent !== null ? sale : regular || sale || q('.price', productInfo);
    return node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function initMobileBuyBar() {
    if (!document.body.classList.contains('template-product') || q('.tm-mobile-buybar')) return;
    const productInfo = q('product-info:not([data-original-section])') || q('product-info');
    if (!productInfo) return;

    const bar = document.createElement('div');
    bar.className = 'tm-mobile-buybar';
    bar.innerHTML = '<div class="tm-mobile-buybar__price" data-tm-mobile-price></div><button class="tm-mobile-buybar__button" type="button" data-tm-mobile-add>Add to cart</button>';
    document.body.appendChild(bar);

    const price = q('[data-tm-mobile-price]', bar);
    const button = q('[data-tm-mobile-add]', bar);
    const sync = () => {
      const original = q('.product-form__submit', productInfo);
      if (price) price.textContent = readablePrice(productInfo);
      if (button) {
        button.disabled = !original || original.disabled;
        const label = original ? q('span', original) : null;
        button.textContent = label ? label.textContent.trim() : (original ? original.textContent.trim() : 'Unavailable');
      }
    };

    button.addEventListener('click', () => {
      const original = q('.product-form__submit', productInfo);
      if (original && !original.disabled) original.click();
    });
    new MutationObserver(sync).observe(productInfo, { childList: true, subtree: true, characterData: true, attributes: true });
    sync();
  }

  function boot() {
    updateStickyOffset();
    initTabs();
    initCarousels();
    initNewArrivals();
    initNewArrivalsArchive();
    initMobileBuyBar();

    const observer = new MutationObserver(() => { initCarousels(); initNewArrivalsArchive(); });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener('resize', requestStickyOffsetUpdate, { passive: true });
  window.addEventListener('scroll', requestStickyOffsetUpdate, { passive: true });
  window.addEventListener('load', () => {
    qa('[data-tm-product-tabs]').forEach((tabs) => primeYotpoReviews(tabs));
  }, { once: true });
  document.addEventListener('shopify:section:load', () => {
    updateStickyOffset();
    initTabs();
    initCarousels();
    initNewArrivals();
    initNewArrivalsArchive();
  });

  if ('ResizeObserver' in window) {
    const header = q('[id^="TMHeader-"]');
    if (header) new ResizeObserver(requestStickyOffsetUpdate).observe(header);
  }
})();
